import { render, staticRenderFns } from "./RawMaterialSlug.vue?vue&type=template&id=2817d65b&"
import script from "./RawMaterialSlug.vue?vue&type=script&lang=js&"
export * from "./RawMaterialSlug.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialSlug.vue?vue&type=style&index=0&id=2817d65b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports